import styled from 'styled-components'

export const TickerHeadingLabelStyled = styled.div.attrs((props) => ({}))`
    font-size: 12px;
    padding-top: 8px;
    padding-left: 4px;
`
